function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useRef, useState, useEffect } from 'react';
import { NavbarContext } from './NavbarContext.js';
import { StyledMobileMenu, StyledMobileMenuPanel } from './Navbar.styles.js';
import ProfileIcon from './ProfileIcon.js';
import NavbarMobileNotifications from './NavbarMobileNotifications.js';
import NavbarMobileMenuItem from './NavbarMobileMenuItem.js';
import NavbarMobileMenuToggleButton from './NavbarMobileMenuToggleButton.js';
import NavbarMobileHelpItem from './NavbarMobileHelpItem.js';
import NavbarMobileMenuNotificationToggleButton from './NavbarMobileMenuNotificationToggleButton.js';
/* eslint-disable max-len */

var NavbarMobileMenu = function NavbarMobileMenu() {
  var _useContext = useContext(NavbarContext),
      navItems = _useContext.navItems,
      helpUrl = _useContext.helpUrl,
      helpTarget = _useContext.helpTarget,
      userMenuItems = _useContext.userMenuItems,
      helpMenuItems = _useContext.helpMenuItems,
      location = _useContext.location,
      isDark = _useContext.isDark,
      notificationMenuItems = _useContext.notificationMenuItems,
      navbarLinkWrapper = _useContext.navbarLinkWrapper,
      helpItemLinkWrapper = _useContext.helpItemLinkWrapper,
      userMenuLinkWrapper = _useContext.userMenuLinkWrapper,
      userInfo = _useContext.userInfo,
      dropdownsExpandedByDefault = _useContext.dropdownsExpandedByDefault,
      showMobileMenu = _useContext.showMobileMenu,
      setShowMobileMenu = _useContext.setShowMobileMenu,
      showMobileNotifications = _useContext.showMobileNotifications,
      setShowMobileNotifications = _useContext.setShowMobileNotifications,
      setShowMobileApplicationSwitcher = _useContext.setShowMobileApplicationSwitcher,
      hasNotificationMenu = _useContext.hasNotificationMenu,
      hasBody = _useContext.hasBody,
      customMobileMenu = _useContext.customMobileMenu,
      helpMenuLocation = _useContext.helpMenuLocation,
      userMenuLocation = _useContext.userMenuLocation,
      hideHelpMenuHeader = _useContext.hideHelpMenuHeader;

  var toggleMenuButton = useRef(null);
  var toggleNotificationsButton = useRef(null);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      subMenusVisible = _useState2[0],
      setSubMenusVisible = _useState2[1]; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var menuItems = useRef([]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Escape') {
      if (showMobileMenu) {
        setShowMobileMenu(false);

        if (toggleMenuButton && toggleMenuButton.current) {
          toggleMenuButton.current.focus();
        }
      }

      if (showMobileNotifications) {
        setShowMobileNotifications(false);

        if (toggleNotificationsButton && toggleNotificationsButton.current) {
          toggleNotificationsButton.current.focus();
        }
      }
    }
  };

  var toggleSubMenu = function toggleSubMenu(item) {
    var copyOfMenuVisible = _toConsumableArray(subMenusVisible);

    if (copyOfMenuVisible.indexOf(item.label) === -1) {
      copyOfMenuVisible.push(item.label);
    } else {
      copyOfMenuVisible = copyOfMenuVisible.filter(function (menuItem) {
        return menuItem !== item.label;
      });
    }

    setSubMenusVisible(copyOfMenuVisible);
  };

  useEffect(function () {
    if (showMobileMenu && menuItems.current && menuItems.current[0] && menuItems.current[0].focus) {
      menuItems.current[0].focus();
    } else {
      menuItems.current = [];
    }
  }, [showMobileMenu]);
  useEffect(function () {
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showMobileMenu, showMobileNotifications]);

  var checkIfDropdownsExpandedByDefault = function checkIfDropdownsExpandedByDefault(label) {
    return dropdownsExpandedByDefault ? subMenusVisible.indexOf(label) === -1 : subMenusVisible.indexOf(label) > -1;
  };

  var toggleMobileMenuPanel = function toggleMobileMenuPanel() {
    setShowMobileMenu(!showMobileMenu);
    setShowMobileNotifications(false);
    setShowMobileApplicationSwitcher(false);
  };

  var toggleNotificationMenu = function toggleNotificationMenu() {
    setShowMobileNotifications(!showMobileNotifications);
    setShowMobileMenu(false);
    setShowMobileApplicationSwitcher(false);
  };

  useEffect(function () {
    navItems.map(function (menuItem) {
      if (menuItem.menuItems) {
        menuItem.menuItems.map(function (subItem) {
          if (subItem.url && subItem.url === location) {
            setSubMenusVisible(function (prev) {
              if (menuItem.label && prev.indexOf(menuItem.label) === -1) {
                prev.push(menuItem.label);
              } else {
                return prev.filter(function (item) {
                  return item !== menuItem.label;
                });
              }

              return prev;
            });
          }
        });
      }
    });
  }, [navItems, location]);
  if (navItems.length > 0 || userMenuItems.length > 0 || helpMenuItems.length > 0 || helpUrl) return React.createElement(StyledMobileMenu, {
    "data-lwt-id": 'navbar-mobile-menu',
    hasNavItems: navItems.length > 0 || hasBody
  }, hasNotificationMenu && React.createElement(NavbarMobileMenuNotificationToggleButton, {
    ref: toggleNotificationsButton,
    menuOpen: showMobileNotifications,
    setMenuOpen: toggleNotificationMenu
  }), React.createElement(NavbarMobileMenuToggleButton, {
    ref: toggleMenuButton,
    menuOpen: showMobileMenu,
    setMenuOpen: toggleMobileMenuPanel
  }), showMobileNotifications && React.createElement(StyledMobileMenuPanel, {
    isDark: isDark
  }, React.createElement(NavbarMobileNotifications, null)), showMobileMenu && React.createElement(StyledMobileMenuPanel, {
    isDark: isDark
  }, React.createElement(React.Fragment, null, customMobileMenu && customMobileMenu, navItems.map(function (item, navItemIndex) {
    return React.createElement(React.Fragment, {
      key: "mobile-nav-item-nav-item-".concat(navItemIndex)
    }, React.createElement("div", {
      className: "helix-unified-navbar__mobile-menu-item ".concat(item.disabled ? 'disabled' : '', " ").concat(item.menuItems ? 'helix-unified-navbar__mobile-menu-item-dropdown' : '', " ").concat(item.url === location ? 'active' : '')
    }, React.createElement(NavbarMobileMenuItem, {
      isOpen: checkIfDropdownsExpandedByDefault(item.label),
      linkWrapper: navbarLinkWrapper,
      ref: function ref(_ref) {
        if (menuItems.current && menuItems.current.indexOf(_ref) === -1 && _ref) {
          menuItems.current.push(_ref);
        }
      },
      onClick: function onClick() {
        return toggleSubMenu(item);
      },
      location: location,
      item: item
    })), item.menuItems && checkIfDropdownsExpandedByDefault(item.label) && item.menuItems.map(function (menuItem, subMenuIndex) {
      return React.createElement("div", {
        key: "mobile-nav-item-submenu-item-".concat(subMenuIndex),
        className: "".concat(menuItem.header ? 'helix-unified-navbar__mobile-menu-header' : 'helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-sub-menu-item', " ").concat(menuItem.url === location ? 'active' : '', " ").concat(menuItem.disabled ? 'disabled' : '')
      }, React.createElement(NavbarMobileMenuItem, {
        linkWrapper: navbarLinkWrapper,
        ref: function ref(_ref2) {
          if (menuItems.current && menuItems.current.indexOf(_ref2) > -1 && _ref2) {
            menuItems.current.push(_ref2);
          }
        },
        location: location,
        item: menuItem
      }));
    }));
  }), (customMobileMenu || navItems.length > 0) && (helpUrl || notificationMenuItems || userMenuItems.length > 0) && React.createElement("hr", {
    className: 'helix-unified-navbar__mobile-menu-divider'
  }), helpUrl && React.createElement(NavbarMobileHelpItem, {
    linkWrapper: helpItemLinkWrapper,
    helpUrl: helpUrl,
    target: helpTarget
  }), helpMenuItems && helpMenuItems.length > 0 && React.createElement(React.Fragment, null, !hideHelpMenuHeader && React.createElement("div", {
    className: 'helix-unified-navbar__mobile-menu-header'
  }, "Help"), helpMenuItems.map(function (item, userIndex) {
    if (item.divider) return React.createElement("hr", {
      key: "mobile-help-item-divider-".concat(userIndex),
      className: 'helix-unified-navbar__mobile-menu-divider'
    });
    return React.createElement("div", {
      key: "mobile-help-item-".concat(userIndex),
      className: "helix-unified-navbar__mobile-menu-item ".concat(helpMenuLocation === item.url ? 'active' : '')
    }, React.createElement(NavbarMobileMenuItem, {
      linkWrapper: userMenuLinkWrapper,
      item: item
    }));
  })), userMenuItems.length > 0 && (helpUrl || notificationMenuItems || helpMenuItems) && React.createElement("hr", {
    className: 'helix-unified-navbar__mobile-menu-divider'
  }), userMenuItems.length > 0 && React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'helix-unified-navbar__mobile-menu-profile-item'
  }, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatarURL) ? React.createElement("div", {
    className: 'helix-unified-nav__user-avatar'
  }, React.createElement("img", {
    src: userInfo.avatarURL,
    alt: 'avatar'
  })) : React.createElement(ProfileIcon, null), ' ', userInfo && React.createElement("div", {
    className: 'helix-unified-navbar__mobile-menu-user-info'
  }, userInfo.name && React.createElement("span", {
    className: 'helix-unified-navbar__mobile-menu-user-info-name'
  }, userInfo.name), userInfo.email && React.createElement("span", {
    className: 'helix-unified-navbar__mobile-menu-user-info-email'
  }, userInfo.email))), userMenuItems.map(function (item, userIndex) {
    if (item.divider) return React.createElement("hr", {
      key: "mobile-user-item-divider-".concat(userIndex),
      className: 'helix-unified-navbar__mobile-menu-divider'
    });
    return React.createElement("div", {
      key: "mobile-user-item-".concat(userIndex),
      className: "helix-unified-navbar__mobile-menu-item ".concat(userMenuLocation === item.url ? 'active' : '')
    }, React.createElement(NavbarMobileMenuItem, {
      linkWrapper: userMenuLinkWrapper,
      item: item
    }));
  })))));
  return React.createElement(React.Fragment, null);
};

export { NavbarMobileMenu as default };